import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Global.css';
import Logo from '../img/logo art director.png';

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };

    const closeDrawer = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className="header">
                <div className="logo">
                    <img src={Logo} alt="Logo" />
                </div>
                <div className={`nav-links ${isOpen ? 'open' : ''}`}>
                    <ul>
                        <li><Link to="/" onClick={closeDrawer}>Home</Link></li>
                        <li><Link to="/projects" onClick={closeDrawer}>My Projects</Link></li>
                        <li><Link to="/about" onClick={closeDrawer}>About</Link></li>
                        <li className='contact-btn'><Link to="/contact" onClick={closeDrawer}>Contact Us</Link></li>
                    </ul>
                </div>
                <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={toggleDrawer}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
            </div>
        </>
    );
};

export default Header;
